module.exports = __webpack_public_path__ + "static/media/petunjuk_psikologi.66cd3285.png";